"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 */
export const Account = createSVGIcon(
  <>
    <path
      d="M8 6.85718C8 7.91804 8.42143 8.93546 9.17157 9.68561C9.92172 10.4358 10.9391 10.8572 12 10.8572C13.0609 10.8572 14.0783 10.4358 14.8284 9.68561C15.5786 8.93546 16 7.91804 16 6.85718C16 5.79631 15.5786 4.7789 14.8284 4.02875C14.0783 3.27861 13.0609 2.85718 12 2.85718C10.9391 2.85718 9.92172 3.27861 9.17157 4.02875C8.42143 4.7789 8 5.79631 8 6.85718V6.85718Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 20.4374C20.3834 18.6936 19.1803 17.1738 17.5634 16.0959C15.9466 15.018 13.999 14.4374 12 14.4374C10.001 14.4374 8.05342 15.018 6.43655 16.0959C4.81968 17.1738 3.61664 18.6936 3 20.4374H21Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Account",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Account",
      description: {
        text: "Message for screenreaders when only the account icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
  })
);
